import { ManuteRequestConfig } from '@/api/types';
import { VacationTypeQueryParams } from '@/api/requests/vacation/types';

/**
 * Request to find all vacation types.
 * @param params
 */
export const ALL = (params?: VacationTypeQueryParams): ManuteRequestConfig => ({
    method: 'GET',
    url: '/vacation-types',
    params: {
        page_size: 50,
        ...params,
    },
});